import { useTranslation } from 'react-i18next';

import { EmptyW, StyledText } from './styled';

export const EmptyCategories = () => {
  const { t } = useTranslation();

  return (
    <EmptyW>
      <StyledText>{t('resources.documentCategories.emptyCategoryState')}</StyledText>
    </EmptyW>
  );
};
